import { FiAlertTriangle, FiX, FiTrash2, FiLoader } from "react-icons/fi";
import { useContext, useState } from "react";
import { BaseContext } from "../../../contexts/BaseContext";
import { deasyWorkflowService } from "../../../services/api";

export const DeletionDialog = ({
  setOpenDeleteDialog,
  selectedWorkflow,
  fetchWorkflows,
}) => {
  const { deasyApiKey } = useContext(BaseContext);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const confirmDelete = async () => {
    try {
      setLoading(true);
      setError(null);

      await deasyWorkflowService.deleteDeasyWorkflow(
        deasyApiKey,
        selectedWorkflow.id,
      );

      await fetchWorkflows();
      setOpenDeleteDialog(false);
    } catch (error) {
      console.error("Failed to delete workflow:", error);
      setError("Failed to delete workflow. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/70 backdrop-blur-sm flex justify-center items-center z-50 animate-fadeIn p-4">
      <div className="bg-white rounded-xl w-full max-w-md shadow-2xl animate-slideIn overflow-hidden mx-auto">
        <div className="flex justify-between items-center p-4 border-b border-gray-200 bg-gray-50">
          <div className="flex items-center">
            <div className="p-2 bg-red-100 rounded-lg text-red-500 mr-3">
              <FiTrash2 className="w-5 h-5" />
            </div>
            <h3 className="text-lg font-bold text-gray-800">
              Confirm Deletion
            </h3>
          </div>
          <button
            className="p-1.5 rounded-lg text-gray-500 hover:text-gray-700 hover:bg-gray-200/70 transition-all"
            onClick={() => !loading && setOpenDeleteDialog(false)}
            disabled={loading}
            aria-label="Close"
          >
            <FiX className="w-5 h-5" />
          </button>
        </div>

        <div className="p-5">
          <div className="bg-red-50 p-4 rounded-lg border border-red-100 mb-5">
            <div className="flex flex-col gap-3">
              <div className="flex items-center gap-2 p-2 bg-red-100 rounded-lg text-red-500 mx-auto">
                <FiAlertTriangle className="w-5 h-5" />
                <h4 className="font-semibold text-red-600 mb-1">Warning</h4>
              </div>
              <p className="text-gray-700 text-sm text-center">
                This action cannot be undone. This will permanently delete the
                workflow and all associated configuration.
              </p>
            </div>
          </div>

          <div className="bg-gray-50 rounded-lg border border-gray-200 p-4 mb-4">
            <p className="text-gray-700 font-medium mb-2 text-sm">
              You are about to delete:
            </p>
            <div className="flex items-center p-3 bg-white rounded-md border border-gray-200">
              <span className="font-bold text-gray-900">
                {selectedWorkflow?.name}
              </span>
            </div>
          </div>

          {error && (
            <div className="mt-3 p-3 bg-red-50 border border-red-200 rounded-lg text-red-600 text-sm">
              {error}
            </div>
          )}
        </div>

        <div className="flex justify-end gap-3 p-4 border-t border-gray-200 bg-gray-50">
          <button
            className="px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 text-gray-700 font-medium transition-colors shadow-sm hover:shadow disabled:opacity-50 text-sm"
            onClick={() => !loading && setOpenDeleteDialog(false)}
            disabled={loading}
          >
            Cancel
          </button>
          <button
            className="px-4 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600 font-medium transition-colors shadow-md hover:shadow-lg flex items-center disabled:opacity-70 text-sm"
            onClick={confirmDelete}
            disabled={loading}
          >
            {loading ? (
              <>
                <FiLoader className="w-4 h-4 mr-2 animate-spin" />
                Deleting...
              </>
            ) : (
              <>
                <FiTrash2 className="w-4 h-4 mr-1.5" />
                Delete Workflow
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};
